export default "__VITE_ASSET__CXrooU_v__"